import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { EOrdenacao } from 'src/app/shared/data/ordenacao.enum';
import { EAccountRole, ERoleAdminString } from 'src/app/shared/data/role.enum';
import { SessionService } from 'src/app/shared/services/session.service';
import { ICadastroAtestado, IListByFilterAtestado } from './models/atestado';
import { SickNoteService } from './services/sick-note.service';

@Component({
  selector: 'app-atestados',
  templateUrl: './atestados.component.html',
  styleUrls: ['./atestados.component.scss']
})
export class AtestadosComponent implements OnInit {
  ERoleAdminString = ERoleAdminString;
  @Output() salvarAtestado = new EventEmitter();
  atestados: ICadastroAtestado[] = [];
  formDisplayed = '';
  acaoInput = new UntypedFormControl();
  ordenarControl = new UntypedFormControl(3);
  opcoesOrdenacao = [
    {
      value: EOrdenacao.AlfabeticaAZ,
      label: 'Alfabética - de A a Z'
    },
    {
      value: EOrdenacao.AlfabeticaZA,
      label: 'Alfabética - de Z a A'
    },
    {
      value: EOrdenacao.MaisNovos,
      label: 'Mais novos'
    },
    {
      value: EOrdenacao.MaisAntigos,
      label: 'Mais antigos'
    }
  ];

  dadosPaginacao = {
    ordenacao: EOrdenacao.MaisNovos,
    paginaSelecionada: 0,
    tamanhoPagina: 10,
    totalPaginas: 0,
    itensTotal: 0,
    periodStart: 0,
    periodEnd: 0
  };

  constructor(private readonly atestadoservice: SickNoteService, private readonly sessionService: SessionService) {}

  ngOnInit(): void {
    this.carregarAtestados();

    this.ordenarControl.valueChanges.subscribe((ordenacaoSelecionada: EOrdenacao) => {
      this.dadosPaginacao.ordenacao = ordenacaoSelecionada;
      this.carregarAtestados();
    });
  }

  filtrarAtestados(): void {
    this.carregarAtestados();
  }

  limparFiltros(): void {
    this.acaoInput.reset();
    this.carregarAtestados();
  }

  carregarAtestados(): void {
    const filtros: IListByFilterAtestado = {
      orderBy: Number(this.dadosPaginacao.ordenacao),
      pageNumber: Number(this.dadosPaginacao.paginaSelecionada),
      pageSize: Number(this.dadosPaginacao.tamanhoPagina)
    };

    const partnerId = this.sessionService.getSession().partnerId;
    const companyId = this.sessionService.getSession().companyId;
    const accountRole = this.sessionService.getSession().accountRole;
    const adminUserId = this.sessionService.getSession().sid;

    if (partnerId) {
      filtros.partnerId = partnerId;
    }

    if (companyId) {
      filtros.companyId = companyId;
    }

    if (accountRole) {
      filtros.accountRole = parseInt(accountRole);
    }

    if (parseInt(accountRole) === EAccountRole.Doctor && adminUserId) {
      filtros.adminUserId = adminUserId;
    }

    if (this.acaoInput.value) {
      filtros.searchText = this.acaoInput.value;
    }

    this.atestadoservice.listarTodosAtestados(filtros).subscribe((res) => {
      this.atestados = res.data;
      this.dadosPaginacao.totalPaginas = Math.ceil(res.count! / this.dadosPaginacao.tamanhoPagina);
      this.dadosPaginacao.itensTotal = res.count!;
    });
  }

  changeForm(formType: string): void {
    this.formDisplayed = formType;
  }

  public mudouPagina(paginaSelecionada: number): void {
    this.dadosPaginacao.paginaSelecionada = paginaSelecionada;

    this.carregarAtestados();
  }

  public mudouTamanhoPagina(itensPaginaSelecionada: number): void {
    this.dadosPaginacao.tamanhoPagina = itensPaginaSelecionada;
    this.dadosPaginacao.paginaSelecionada = 0;

    this.carregarAtestados();
  }

  public downloadExcel(): void {
    this.atestadoservice.exportarExcel();
  }
}
